import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environment/environment';
var TasksService = /** @class */ (function () {
    function TasksService(httpClient) {
        this.httpClient = httpClient;
        this.apiBase = environment.API_BASE;
    }
    /**
     * Get list of tasks for this user
     * @method getTasks
     */
    TasksService.prototype.getTasks = function (taskType, payload) {
        var params = new HttpParams();
        var url = this.apiBase + ("/api/tasks/?status=" + taskType);
        if (payload) {
            Object.entries(payload).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (value !== undefined) {
                    params = params.append(key, value);
                }
            });
        }
        return this.httpClient.get(url, { params: params });
    };
    return TasksService;
}());
export { TasksService };
